/**
Project: Voice Panel (c)
Title: Sign Out page 
Description: Component for sign out
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Component } from "react";
import PageUtil from "../helpers/page-util";
import { msalInstance } from "../settings/msal-config";
import { AppConstants } from "../settings/app-constants";
import { AppURLProps } from "../settings/app-urls";
import { accessLogWithToken } from "../actions/common-actions";
import TokenUtil from "../helpers/token-util";
import { connect } from "react-redux";
import { setClientNavigator } from "../actions/common-actions";
import { getAppInsights } from "../settings/azure-insights-config";

class SignOut extends Component {
  _azureInsights = getAppInsights();
  async componentDidMount() {
    await this.props.setClientNavigator();
    await this.signout();
  }
  signout = async () => {
    let token = TokenUtil.getIdentitySippioAccessToken();

    accessLogWithToken(
      PageUtil.getPageURL(this.props.history.location),
      "UID-SOT",
      "Sign-out",
      token

    );
    await this._azureInsights.clearAuthenticatedUserContext();
    await TokenUtil.removeIdentityToken();
    if (
      this.props.clientNavigator &&
      this.props.clientNavigator.accessMode ===
        AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_REGULAR_BROWSER
    ) {
      let account = msalInstance.getActiveAccount();
      msalInstance.logoutRedirect({
        account: account,
      });
      localStorage.clear();
      return;
    } else {
      this.props.history.push(AppURLProps.signin);
      localStorage.clear();
      return;
    }
  };

  render() {
    return <></>;
  }
}

const mapStateToProps = (state) => ({
  clientNavigator: state.appSettings.clientNavigator,
});
const mapActionToProps = {
  setClientNavigator,
};
export default connect(mapStateToProps, mapActionToProps)(SignOut);
